import React from 'react';
import {
  withLoading,
  useTranslator,
  MarkdownRenderer,
  Faq,
  useAppContext,
} from '@front-activerse/common-components';
import { Helmet } from 'react-helmet';
import { Container, Row, Col } from 'reactstrap';
import Layout from '../Layout/Layout';
import UniversalPlaceholder from '../Layout/UniversalPlaceholder';
import TitleBar from '../Layout/TitleBar';

const TermsOfService = ({ content, content2, content3, content4 }) => {
  const { t } = useTranslator();
  const {
    svgInline: { DownArrow },
  } = useAppContext();

  return (
    <Layout simpleLayout>
      <TitleBar showBackBtn={false}>{t('termsOfService.navbarTitle')}</TitleBar>
      <Helmet>
        <title>{t('termsOfService.navbarTitle')}</title>
        <meta name="description" content="" />
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <div className="page-template-content full-height7">
        <Container className="py-md-4">
          <Row>
            <Col xl={{ size: 10, offset: 1 }}>
              <div className="page-container">
                <div className="content-container">
                  <div className="cms-content">
                    <section className="faq-section">
                      {content3.content?.markdown && (
                        <Faq
                          question={t('termsOfService.web')}
                          answer={<MarkdownRenderer content={content3.content.markdown} />}
                          downArrow={DownArrow}
                        />
                      )}

                      {content.content?.markdown && (
                        <Faq
                          question={t('termsOfService.android')}
                          answer={<MarkdownRenderer content={content.content.markdown} />}
                          downArrow={DownArrow}
                        />
                      )}

                      {content2.content?.markdown && (
                        <Faq
                          question={t('termsOfService.ios')}
                          answer={<MarkdownRenderer content={content2.content.markdown} />}
                          downArrow={DownArrow}
                        />
                      )}

                      {content4.content?.markdown && (
                        <Faq
                          question={t('termsOfService.huawei')}
                          answer={<MarkdownRenderer content={content4.content.markdown} />}
                          downArrow={DownArrow}
                        />
                      )}
                    </section>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

const Placeholder = () => <UniversalPlaceholder simpleLayout fullHeightMinusHeader />;

export default withLoading(TermsOfService, Placeholder);
